import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  
  try {
    // Priority 1: Direct component passed as prop
    if (icon) {
      IconComponent = icon;
    } 
    // Priority 2: String name passed (e.g., "User" -> FiUser)
    else if (name) {
      const iconName = `Fi${name}`;
      IconComponent = FiIcons[iconName];
    }
  } catch (e) {
    console.warn(`Icon load failed for ${name}`, e);
    IconComponent = null;
  }

  // Fallback if no icon found
  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} className={`text-yellow-500 ${props.className || ''}`} />;
};

export default SafeIcon;